import { FormFieldsContainer } from '../Shared/styles'
import Info from 'components/inputs/Material/Info/index'
import FooterButtons from 'components/inputs/Material/FooterButtons/index'
import { SimpleQuestionFields } from 'components/inputs'

export default function SimpleQuestion() {
  return (
    <>
      <FormFieldsContainer>
        <Info />
        <SimpleQuestionFields />
      </FormFieldsContainer>
      <FooterButtons showLogicButton={false} />
    </>
  )
}
